import React from "react";
import escenas from "../simples/escenas";
import frases from "../simples/frases";
import CuadroDiagrama from "./CuadroDiagrama";
import { BotonVoz } from "../voz";
import { Glosa } from "../piezas";

// «En palabras simples»: una analogia cotidiana para cada servicio y, en los basicos, su propia escena animada.
export const tieneEscena = (id) => !!escenas[id];
export const fraseSimple = (id) => frases[id];

const Simple = ({ id, titulo, color }) => {
    const e = escenas[id];
    const f = frases[id];
    if (!f) return null;
    const lectura = `${titulo}, en palabras simples. ${e ? e.analogia + ". " + e.pasos.join(" ") + " Ojo: " + e.ojo : f}`;
    return (
        <div className="card mb-3" style={{ borderTop: `4px solid ${color}`, background: "var(--cui-tertiary-bg, #f8f9fa)" }} data-guia="simple">
            <div className="card-body">
                <div className="d-flex align-items-start flex-wrap gap-2 mb-1">
                    <div className="fw-bold me-auto"><i className="fa fa-lightbulb me-2 text-warning" />En palabras simples{e ? `: ${e.analogia}` : ""}</div>
                    <BotonVoz texto={lectura} />
                </div>
                <p className="mb-2" style={{ fontSize: 17 }}>{f}</p>
                {e && (
                    <>
                        <CuadroDiagrama key={id} patron="libre" nodos={e.nodos} flujos={e.flujos} color={color} pasos={e.pasos} permitirFalla={false} />
                        <div className="mt-3">
                            <div className="fw-bold small mb-1"><i className="fa fa-exchange-alt me-1" />Cómo se llama en AWS</div>
                            <ul className="list-unstyled mb-2 small">
                                {e.real.map(([a, b]) => <li key={a}><span className="badge text-bg-light me-2">{a}</span>= <b>{b}</b></li>)}
                            </ul>
                        </div>
                        <div className="alert alert-warning py-2 small mb-0"><i className="fa fa-exclamation-circle me-1" /><b>Ojo:</b> <Glosa texto={e.ojo} /></div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Simple;
